import _ from 'lodash';
// export const createLoadingSelector = (actions) => (state) => {
//   // returns true only when all actions is not loading
//   console.log(actions, state)
//   return _(actions)
//     .some((action) => _.get(state, `api.loading.${action}`));
// };

export const createLoadingSelector = actions => state =>
 actions.some(action => state.isFatching[action]);